export default function ModulosPoder() {
  const arsenal = [
    {
      id: 1,
      categoria: 'Categoría 1',
      title: 'Inteligencia de Mercado',
      subtitle: 'El Radar que Detecta Oportunidades Ocultas',
      description: 'Deja de adivinar qué vender. Nuestro sistema de inteligencia artificial escanea miles de nichos en tiempo real para identificar productos digitales con demanda real y baja competencia.',
      features: [
        {
          icon: 'ri-radar-line',
          title: 'Análisis de Nichos Desatendidos',
          desc: 'Identifica mercados con alta demanda pero poca oferta de calidad. El algoritmo detecta gaps de mercado que otros pasan por alto.'
        },
        {
          icon: 'ri-file-search-line',
          title: 'Detección de Tendencias en PDFs y Descargables',
          desc: 'Escanea qué tipos de productos digitales están generando más búsquedas, descargas y conversiones en plataformas de venta.'
        },
        {
          icon: 'ri-bar-chart-box-line',
          title: 'Nivel de Competencia Real',
          desc: 'No solo te muestra el nicho, sino cuántos competidores hay, qué tan saturado está y tu probabilidad real de éxito.'
        }
      ],
      iconBg: 'bg-[#FF6B35]/10',
      iconColor: 'text-[#FF6B35]',
      borderColor: 'border-[#FF6B35]/30',
      image: 'https://readdy.ai/api/search-image?query=professional%20market%20intelligence%20dashboard%20showing%20real-time%20niche%20analysis%20with%20data%20visualization%20charts%20graphs%20and%20trend%20detection%20metrics%2C%20clean%20white%20interface%20with%20orange%20accent%20colors%20displaying%20competitive%20analysis%20and%20market%20opportunity%20scores%2C%20modern%20analytics%20software%20with%20organized%20data%20panels%20showing%20PDF%20downloads%20statistics%20and%20market%20demand%20indicators%2C%20sophisticated%20business%20intelligence%20tool%20with%20clear%20typography&width=900&height=650&seq=arsenal-inteligencia-mercado-001&orientation=landscape'
    },
    {
      id: 2,
      categoria: 'Categoría 2',
      title: 'Ingeniería de Creativos',
      subtitle: 'El Estudio de Diseño que Nunca Duerme',
      description: 'Genera imágenes publicitarias de alto impacto en segundos. Sin diseñadores, sin Photoshop, sin complicaciones. Solo resultados que convierten.',
      features: [
        {
          icon: 'ri-image-ai-line',
          title: 'Generación de Imágenes Publicitarias con IA',
          desc: 'Crea banners, posts para redes sociales y creativos de anuncios con un solo clic. La IA entiende tu producto y genera diseños optimizados para conversión.'
        },
        {
          icon: 'ri-video-line',
          title: 'Briefs para Videos de Venta',
          desc: 'Recibe guiones completos y storyboards para tus videos de venta. Estructura PAS, ganchos emocionales y llamados a la acción incluidos.'
        },
        {
          icon: 'ri-layout-grid-line',
          title: 'Layouts de Alto CTR',
          desc: 'Plantillas de diseño probadas que generan clics. Basadas en análisis de miles de campañas exitosas en Facebook Ads, Instagram y Google.'
        }
      ],
      iconBg: 'bg-[#00D9FF]/10',
      iconColor: 'text-[#00D9FF]',
      borderColor: 'border-[#00D9FF]/30',
      image: 'https://readdy.ai/api/search-image?query=creative%20design%20studio%20interface%20showing%20AI-generated%20advertising%20materials%20with%20multiple%20promotional%20graphics%20and%20social%20media%20posts%20displayed%20in%20grid%20layout%2C%20modern%20design%20software%20with%20cyan%20accent%20colors%20featuring%20video%20storyboard%20panels%20and%20high-converting%20ad%20templates%2C%20professional%20marketing%20creative%20workspace%20with%20organized%20visual%20assets%20and%20CTR-optimized%20layouts%2C%20clean%20white%20background%20with%20vibrant%20commercial%20designs&width=900&height=650&seq=arsenal-creativos-002&orientation=landscape'
    },
    {
      id: 3,
      categoria: 'Categoría 3',
      title: 'El Arquitecto de Prompts NASA',
      subtitle: 'Prompts de Nivel Profesional al Instante',
      description: 'Accede a la biblioteca de prompts más avanzada del mercado. Diseñados por ingenieros de IA para obtener respuestas de experto en cualquier tema.',
      features: [
        {
          icon: 'ri-code-s-slash-line',
          title: 'Prompts Estructurados para ChatGPT/Claude',
          desc: 'Más de 200 prompts profesionales organizados por categoría: copywriting, análisis de mercado, creación de productos, estrategias de venta y más.'
        },
        {
          icon: 'ri-lightbulb-flash-line',
          title: 'Eliminación del Bloqueo Creativo',
          desc: 'Nunca más te quedarás sin ideas. Cada prompt está diseñado para desbloquear creatividad y generar contenido original en minutos.'
        },
        {
          icon: 'ri-brain-line',
          title: 'Respuestas de Experto Garantizadas',
          desc: 'Los prompts incluyen contexto, rol y formato específico para que la IA responda como un consultor senior con años de experiencia.'
        }
      ],
      iconBg: 'bg-[#FF6B35]/10',
      iconColor: 'text-[#FF6B35]',
      borderColor: 'border-[#FF6B35]/30',
      image: 'https://readdy.ai/api/search-image?query=dark%20terminal%20interface%20displaying%20advanced%20AI%20prompt%20engineering%20commands%20with%20glowing%20orange%20text%20on%20black%20background%2C%20professional%20code%20editor%20showing%20structured%20ChatGPT%20prompts%20and%20Claude%20AI%20instructions%2C%20futuristic%20command%20line%20workspace%20with%20organized%20prompt%20library%20categories%20and%20expert-level%20AI%20responses%2C%20sophisticated%20developer%20environment%20with%20monospace%20font%20and%20syntax%20highlighting%20for%20prompt%20templates&width=900&height=650&seq=arsenal-prompts-nasa-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 px-4 sm:px-5 py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-4 sm:mb-6">
            <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
            <span className="text-[#FF6B00] text-xs sm:text-sm font-bold tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>
              TECNOLOGÍA AVANZADA
            </span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#0A0A0A] leading-tight mb-3 sm:mb-4 px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            El Arsenal de <span className="text-[#FF6B00]">Nexus</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#0A0A0A]/70 max-w-3xl mx-auto px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Tres sistemas de inteligencia artificial trabajando en conjunto para dominar el mercado digital
          </p>
        </div>

        {/* Arsenal Cards */}
        <div className="space-y-16 sm:space-y-20 lg:space-y-24">
          {arsenal.map((item, index) => (
            <div 
              key={item.id}
              className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center"
            >
              
              {/* Content Column */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="inline-block px-3 sm:px-4 py-1.5 bg-white border-2 border-[#E0E0DE] rounded-full mb-3 sm:mb-4">
                  <span className="text-xs sm:text-sm font-bold text-[#0A0A0A]/60" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {item.categoria}
                  </span>
                </div>
                
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#0A0A0A] mb-2 sm:mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {item.title}
                </h3>
                
                <p className="text-base sm:text-lg font-semibold text-[#FF6B00] mb-3 sm:mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {item.subtitle}
                </p>
                
                <p className="text-sm sm:text-base text-[#0A0A0A]/70 leading-relaxed mb-6 sm:mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {item.description}
                </p>

                {/* Features List */}
                <div className="space-y-4 sm:space-y-6">
                  {item.features.map((feature, idx) => (
                    <div key={idx} className="flex gap-3 sm:gap-4">
                      <div className={`w-10 h-10 sm:w-12 sm:h-12 ${item.iconBg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                        <i className={`${feature.icon} ${item.iconColor} text-lg sm:text-xl`}></i>
                      </div>
                      <div>
                        <h4 className="text-base sm:text-lg font-bold text-[#0A0A0A] mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                          {feature.title}
                        </h4>
                        <p className="text-xs sm:text-sm text-[#0A0A0A]/70 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                          {feature.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Image Column */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className={`relative bg-white rounded-2xl sm:rounded-3xl border-2 ${item.borderColor} shadow-[0_8px_32px_rgba(0,0,0,0.08)] overflow-hidden group cursor-pointer hover:shadow-[0_16px_48px_rgba(0,0,0,0.12)] transition-all duration-500`}>
                  <div className="aspect-[4/3] overflow-hidden">
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  
                  {/* Overlay Badge */}
                  <div className="absolute top-4 right-4 sm:top-6 sm:right-6 px-3 sm:px-4 py-1.5 sm:py-2 bg-black/80 backdrop-blur-sm rounded-full">
                    <span className="text-white text-xs font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      IA AVANZADA
                    </span>
                  </div>
                </div>
              </div>

            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 sm:mt-20 text-center">
          <div className="inline-flex flex-col items-center gap-3 sm:gap-4 px-6 sm:px-8 lg:px-12 py-8 sm:py-10 bg-gradient-to-br from-[#FF6B00]/5 to-[#00D9FF]/5 border-2 border-[#FF6B00]/20 rounded-2xl sm:rounded-3xl w-full sm:w-auto">
            <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#0A0A0A] px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Los 3 Módulos + Bonos Exclusivos
            </p>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#FF6B00]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              S/ 25 — Acceso Anual Completo
            </p>
            <button
              onClick={() => {
                const offerSection = document.getElementById('oferta-section');
                if (offerSection) {
                  offerSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-[#FF6B00] text-white font-black rounded-full shadow-[0_8px_32px_rgba(255,107,0,0.4)] hover:shadow-[0_12px_40px_rgba(255,107,0,0.6)] hover:bg-[#e05e00] transition-all cursor-pointer text-base sm:text-lg leading-snug text-center"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <span className="sm:hidden">Acceder Ahora al<br />Arsenal Completo</span>
              <span className="hidden sm:inline">Acceder Ahora al Arsenal Completo</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}